import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    employeeList: [],
    employeeView: null,
    employeeEdit: null,
    employeeAll: [],
    employeeDropdown: [],
    selectedEmployee: null,
    loading: false,
    error: null,
};

export const employeeSlice = createSlice({
    name: "employee",
    initialState,
    reducers: {
        getEmployee: (state, { payload }) => {
            state.employeeList = payload;
        },
        setEmployeeList: (state, action) => {
            state.employeeList = action.payload;
        },
        setEmployeeView: (state, action) => {
            state.employeeView = action.payload;
        },
        setSelectedEmployee: (state, action) => {
    state.selectedEmployee = action.payload;
},
        setEmployeeEdit: (state, action) => {
            state.employeeEdit = action.payload;
        },
        setEmployeeAll: (state, action) => {
            state.employeeAll = action.payload;
        },
        setEmployeeDropdown: (state, action) => {
            state.employeeDropdown = action.payload;
        },
    },
});

export const {
    getEmployee,
    setEmployeeList,
    setEmployeeView,
    setEmployeeEdit,
    setEmployeeAll,
    setEmployeeDropdown,
    setSelectedEmployee
} = employeeSlice.actions;

export default employeeSlice.reducer;
